import { useAuth0 } from "@/Contexts";
import { LoadingIndicator } from "@/Icons/loadingIndicator";
import { useSelectedSite } from "@/api/hooks/useSelectedSite";
import { useSites } from "@/api/hooks/useSites";
import { Button } from "@/components/button";
import { useTrans } from "@/translations";

import React, { useEffect } from "react";

import { sortBy } from "lodash";

const SitePicker: React.FC = () => {
  const { setSelectedSite } = useSelectedSite();
  const { t } = useTrans();
  const { logout } = useAuth0()!;

  const { sites, isLoading } = useSites();

  useEffect(() => {
    const urlSite = window.location.pathname.split("/")?.[1];
    const siteFromUrl = sites?.find((s) => s.siteName === urlSite);
    if (siteFromUrl) {
      setSelectedSite(siteFromUrl);
    } else if (sites?.length === 1 && sites[0]) {
      setSelectedSite(sites[0]);
    }
  }, [sites, setSelectedSite]);

  const sortedSites = sortBy(
    sites?.filter((s) => !!s.siteName && !!s.displayName),
    (s) => s.displayName,
  );

  const hasAccessToAnySites = !!sortedSites.length;

  if (isLoading) {
    return (
      <div className="flex min-h-[300px] items-center justify-center">
        <LoadingIndicator />
      </div>
    );
  }

  return (
    <div className="flex h-screen flex-col justify-center bg-gray-100">
      <Button
        className="absolute top-4 right-4"
        onClick={() =>
          logout({ logoutParams: { returnTo: window.location.origin } })
        }
        label={t("actions:logout")}
      />
      <div className="mt-8 text-center">
        <h1 className="font-signifier mb-4 text-2xl font-bold">
          {t(
            hasAccessToAnySites
              ? "genericLabels:selectSite"
              : "genericLabels:noAvailableSites",
          )}
        </h1>
        <p className="font-dm-sans mb-6">
          {t(
            hasAccessToAnySites
              ? "hints:youHaveMultipleSites"
              : "hints:youHaveNoAccessToSites",
          )}
        </p>
      </div>
      {hasAccessToAnySites && (
        <div className="flex flex-1 justify-center overflow-auto">
          <ul className="w-full max-w-96 space-y-4">
            {sortedSites.map((site) => (
              <li
                key={site.id}
                className="border border-gray-300 p-4 shadow-xs transition hover:border-gray-400 hover:shadow-md"
                onClick={() => setSelectedSite(site)}
              >
                <h2 className="font-dm-sans text-lg font-semibold">
                  {site.displayName}
                </h2>
              </li>
            ))}
            <li className="h-8" /> {/* Spacer */}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SitePicker;
